/** @format */

export const initialState = {
  info: {},
  homeId: null,
  freePlaceData: {},
  homeExpanded: false,
  mode: 'VIEW',
  refetchHomes: () => {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'setInfo':
      return { ...state, info: action.payload };
    case 'setMode':
      return { ...state, mode: action.payload };
    case 'setHomeId':
      return { ...state, homeId: action.payload };
    case 'setRefetchHomes':
      return { ...state, refetchHomes: action.payload };
    case 'setFreePlaceData':
      return { ...state, freePlaceData: action.payload };
    case 'setHomeExpanded':
      return { ...state, homeExpanded: action.payload };
    default:
      return state;
  }
};
